import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "siteName2Component" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "mb-0 fs-7" }
const _hoisted_4 = { class: "text-danger fs-7" }
const _hoisted_5 = ["name"]
const _hoisted_6 = { id: "siteUrl2Component" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "mb-0 fs-7" }
const _hoisted_9 = ["name"]

import { MAX_LENGTH_SITE_NAME, MAX_LENGTH_SITE_URL } from '@/constants/validate'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { PropType } from 'vue'
import { ErrorObject } from '@vuelidate/core'
import { countCharInSurrogatePair } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  siteName: {
    type: Object as PropType<{ $errors: ErrorObject[]; $model: unknown; $error: boolean; [key: string]: any }>,
    required: true,
  },
  siteUrl: {
    type: Object as PropType<{ $errors: ErrorObject[]; $model: unknown; $error: boolean; [key: string]: any }>,
    required: true,
  },
  siteNameLabel: String,
  siteUrlLabel: String,
  siteNameId: String,
  siteUrlId: String,
  onFieldBlur: { type: Function, required: true },
  siteNameValidateMsg: { type: String, default: null },
  siteUrlValidateMsg: { type: String, default: null },
},
  setup(__props) {

const textCounter = (maxLength: number, currentLength: number): number => {
  return maxLength - currentLength
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.siteNameLabel), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(textCounter(_unref(MAX_LENGTH_SITE_NAME), _unref(countCharInSurrogatePair)(__props.siteName?.$model))), 1)
      ]),
      _withDirectives(_createElementVNode("input", {
        name: __props.siteNameId,
        type: "text",
        class: _normalizeClass(['form-control mb-2', __props.siteName?.$error ? 'is-invalid' : '']),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.siteName.$model) = $event)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (__props.onFieldBlur(__props.siteNameId)))
      }, null, 42, _hoisted_5), [
        [
          _vModelText,
          __props.siteName.$model,
          void 0,
          { trim: true }
        ]
      ]),
      _createVNode(InputErrorMessage, {
        title: __props.siteNameLabel,
        message: __props.siteNameValidateMsg,
        validator: __props.siteName.$errors[0]?.$validator === '$externalResults' ? __props.siteName.$errors[0].$message.toString() : __props.siteName.$errors[0]?.$validator,
        params: [1, _unref(MAX_LENGTH_SITE_NAME)]
      }, null, 8, ["title", "message", "validator", "params"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.siteUrlLabel), 1)
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: __props.siteUrlId,
        class: _normalizeClass(['form-control mb-2', __props.siteUrl.$error ? 'is-invalid' : '']),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.siteUrl.$model) = $event))
      }, null, 10, _hoisted_9), [
        [
          _vModelText,
          __props.siteUrl.$model,
          void 0,
          { trim: true }
        ]
      ]),
      _createVNode(InputErrorMessage, {
        title: __props.siteUrlLabel,
        message: __props.siteUrlValidateMsg,
        validator: __props.siteUrl.$errors[0]?.$validator,
        params: [1, _unref(MAX_LENGTH_SITE_URL)]
      }, null, 8, ["title", "message", "validator", "params"])
    ])
  ]))
}
}

})